<template>
  <div class="fundStatementDetailVO">

    <div class="serchFilter" style="padding-top: 0">
      <table border="0" cellpadding="0" cellspacing="0">
        <tr>
          <td><label>{{$t('financing.startTime')+'：'}}</label></td>
          <td>
            <el-date-picker
              v-model="startTime"
              class="w-250"
              type="date"
              :placeholder="$t('loan.selectTime')">
            </el-date-picker>

          </td>
          <td style="padding-left:10px;"><label>{{$t('financing.endTime')+'：'}}</label></td>
          <td>
            <el-date-picker v-model="endTime" class="w-250" type="date" :placeholder="$t('loan.selectTime')"></el-date-picker>
          </td>
        </tr>
        <tr>
          <td><label>{{$t('flowLists.flowNumber')+'：'}}</label></td>
          <td>
            <el-input :placeholder="$t('financing.pleaseWrite')" clearable class="w-250"
                      v-model.trim="searchFlowNumber"></el-input>
          </td>
        </tr>
      </table>
      <div style="text-align:center;margin:0 auto 30px;">
        <el-button type="primary" style="width: 150px;" @click="getFundStateDetailList()">{{$t('financing.view')}}
        </el-button>
        <el-button type="primary" plain style="width: 150px; margin-left: 20px;" @click="exportFundStateList()">{{
          $t("allorders.export") }}
        </el-button>
      </div>
    </div>

    <div class="detail-tableView">
      <div class="tb-left" ref="tbLeft" @scroll="scrollLeft"  :class="roundTurnNameList.length ? '':'scroll'">
        <div class="tb-h" :style="{top:topLeft+'px'}">
          <table class="fundStatementDetail-table dateTable">
            <thead>
            <tr>
              <th>{{ $t("financingFundDetail.date") }}</th>
              <th>{{ $t("poolOfMoney_page.initialPrice") }}</th>
              <th style="width: 140px">{{ $t("poolOfMoney_page.initialTotalPayment") }}</th>
              <th style="width: 130px">{{ $t("poolOfMoney_page.initialTotalProceed") }}</th>
              <th>{{ $t("poolOfMoney_page.initialTotalBalance") }}</th>
            </tr>
            </thead>
          </table>
        </div>
        <div class="tb-b">
          <table class="fundStatementDetail-table dateTable" :style="{marginTop: '-'+topRight+'px'}">
            <tbody>
            <tr v-for="(item, index) in fundStateDetailList" :key="index">
              <td>
                {{item.financeDateStr}}
              </td>
              <td>
                <span v-if="item.startQuota" style="color: #606266">{{item.startQuota | formatNum}}</span>
                <span v-else style="color: #606266">-</span>
              </td>
              <td style="color: #606266;width: 140px">
                <span v-if="item.totalPayment">{{item.totalPayment | formatNum}}</span>
                <span v-else>-</span>
              </td>
              <td style="width: 130px;">
                <span v-if="item.totalCollection">{{item.totalCollection | formatNum}}</span>
                <span v-else>-</span>
              </td>
              <td>
                <span v-if="item.surplusQuota">{{item.surplusQuota | formatNum}}</span>
                <span v-else>-</span>
              </td>
            </tr>
            </tbody>
          </table>
          <!--      左侧固定信息-->
        </div>
      </div>
      <div class="tb-right" ref="tbRight" @scroll="scrollRight" v-if="roundTurnNameList.length">
        <div class="tb-h" :style="{top:topRight+'px'}">
          <table class="fundStatementDetail-table priceTable" :style="{width:tableWidth}">
            <thead>
            <tr>
              <!--        循环遍历，有多个卖方、买房ID-->
              <th v-for="(item, index) in roundTurnCodeList" :key="index">{{item}}</th>
            </tr>
            <tr>
              <!--        循环遍历，有多个卖方、买房名称-->
              <th v-for="(item, index) in roundTurnNameList" :key="index">
                <p class="companyName ellipsis" :title="item">{{item}}</p>
              </th>
            </tr>
            <tr>
              <!--        循环遍历，付款、收款 -->
              <th v-for="(item, index) in roundTurnNameList" :key="index">
                <span v-if="index % 2 == 0">{{ $t("poolOfMoney_page.payment") }}</span>
                <span v-else-if="index%2==1">{{ $t("poolOfMoney_page.proceed") }}</span>
              </th>
            </tr>
            </thead>
          </table>
        </div>
        <div class="tb-b">
          <table class="fundStatementDetail-table priceTable" :style="{width:tableWidth}">
            <!--          <thead>-->
            <!--          <tr>-->
            <!--            &lt;!&ndash;        循环遍历，有多个卖方、买房ID&ndash;&gt;-->
            <!--            <th v-for="(item, index) in roundTurnCodeList" :key="index">{{item}}</th>-->
            <!--          </tr>-->
            <!--          <tr>-->
            <!--            &lt;!&ndash;        循环遍历，有多个卖方、买房名称&ndash;&gt;-->
            <!--            <th v-for="(item, index) in roundTurnNameList" :key="index">{{item}}</th>-->
            <!--          </tr>-->
            <!--          <tr>-->
            <!--            &lt;!&ndash;        循环遍历，付款、收款 &ndash;&gt;-->
            <!--            <th v-for="(item, index) in roundTurnNameList" :key="index">-->
            <!--              <span v-if="index % 2 == 0">{{ $t("poolOfMoney_page.payment") }}</span>-->
            <!--              <span v-else-if="index%2==1">{{ $t("poolOfMoney_page.proceed") }}</span>-->
            <!--            </th>-->
            <!--          </tr>-->
            <!--          </thead>-->
            <tbody>
            <tr v-for="(item, index) in fundStateDetailList" :key="index">
              <td v-for="(subItem, index) in item.rows" :key="index"
                  :style="{background:dateMoneyBackColorList[index]}">
              <span v-if="subItem.esMoney || subItem.realMoney">
                <span v-if="subItem.esMoney" style="color: #606266">{{subItem.esMoney | formatNum}}</span>
                <span v-if="subItem.esMoney && subItem.realMoney" style="color: #32BCAD">+</span>
                <span v-if="subItem.realMoney" style="color: #32BCAD">{{subItem.realMoney | formatNum}}</span>
              </span>
                <span v-else style="color: #606266">-</span>
              </td>
            </tr>
            </tbody>
          </table>
          <!--        </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import utils from "@/helper/utils";
  import dayjs from "dayjs";

  export default {
    name: "fundStatementDetail",
    data() {
      return {
        roundTurnCodeList: [],  //买卖双方的ID值列表
        roundTurnNameList: [],  //买卖双方的名称列表

        fundStateDetailList: [],
        tableWidth: '1000px',

        startTime: '', // 查询 开始时间
        endTime: '', //查询 结束时间
        searchFlowNumber: '', // 流水号查询
        dateMoneyBackColorList: [],

        topLeft:'', // 滚动高度
        topRight:'', // 滚动高度
      }
    },
    created() {
      //查询最后预计收款的日期,再去获取列表
      this.getLastDate()

      // this.getFundStateDetailList()
    },
    methods: {
      // query(){
      //   this.getFundStateDetailList()
      // },
      getLastDate() {
        let _this = this
        let params = {};
        this.axios.post("/zma/api/zmaFundingPool/seachLastDate", params).then(res => {
          if (res.status) {
            _this.startTime = res.data['startDate'];
            _this.endTime = res.data['lastDate'];
            //获取到最后预计收款的日期，就以这个日期去获取资金池列表
            _this.getFundStateDetailList()
          } else {
            this.$message.error(this.$t(`poolOfMoney_error.${res.errorCode}`));
            if (res.errorCode == "loan_audit_50000031") {
              setTimeout(function () {
                window.location.reload();
              }, 1500);
            }
          }
        }); // 查询最后预计收款的日期
      },

      getFundStateDetailList() {
        let _this = this;
        if(_this.roundTurnNameList.length>0){
          _this.$refs.tbLeft.scrollTop = 0;
          _this.$refs.tbRight.scrollTop = 0;
        }
        let startTime =this.startTime ? dayjs(this.startTime).format("YYYY-MM-DD") : '';
        let endTime = this.endTime ? dayjs(this.endTime).format("YYYY-MM-DD") : '';
        let languageCode = window.localStorage.getItem("languageCode") || 'zh_cn'
        let params = {
          // searchTime: endTime,

          startTime:startTime,
          flowNumber:_this.searchFlowNumber,
          endTime: endTime,
          language: languageCode
        };
        this.axios.post("/zma/api/zmaFundingPool/flow", params).then(res => {
          console.log("获取资金表详情");
          // console.log(res);
          if (res.status) {
            _this.parseHeader(res.data)
            _this.parseDetail(res.data)
            _this.parseBackColor(res.data)
          } else {
            _this.$message.error(this.$t(`poolOfMoney_error.${res.errorCode}`));
            if (res.errorCode == "loan_audit_50000031") {
              setTimeout(function () {
                window.location.reload();
              }, 1500);
            }
          }
        });
      },

      //编辑table表头的数据
      parseHeader(data) {
        var tempRoundTurnCodeList = []
        var tempRoundTurnNameList = []

        let flowInfoList = data['flowList']
        if (flowInfoList) {
          for (let i = 0; i < flowInfoList.length; i++) {
            let flowDetailItem = flowInfoList[i]
            // let sellerTitle = this.$t('forfait.seller') + ': ' + (flowDetailItem['sellCompanyName'] ? flowDetailItem['sellCompanyName'] : '')
            // let buyerTitle = this.$t('forfait.buyer') + ': ' + (flowDetailItem['buyCompanyName'] ? flowDetailItem['buyCompanyName'] : '')
            let sellerTitle = flowDetailItem['sellCompanyName'] ? flowDetailItem['sellCompanyName'] : '';
            let buyerTitle = flowDetailItem['buyCompanyName'] ? flowDetailItem['buyCompanyName'] : '';
            tempRoundTurnNameList.push(sellerTitle);  //卖家名称
            tempRoundTurnNameList.push(buyerTitle); //买家名称
            tempRoundTurnCodeList.push(flowDetailItem['flowNumber']); //融资流水号
            tempRoundTurnCodeList.push(flowDetailItem['contractCode'] ? flowDetailItem['contractCode'] : ''); //合同编号

          }
        }

        this.roundTurnCodeList = tempRoundTurnCodeList;
        this.roundTurnNameList = tempRoundTurnNameList;

        this.tableWidth = ((this.roundTurnCodeList.length + 1) * 150 - 150) + 'px'


      },

      //编辑列表数据
      parseDetail(data) {
        var tableList = []
        let dataList = data['moneyList']
        if (dataList) {
          for (let i = 0; i < dataList.length; i++) {
            let flowDetailItem = dataList[i];
            let dateMoneyList = flowDetailItem['dateMoneyList']
            var lineItem = {
              date: '',
              rows: [],
            }
            var dateItem = []    //每一天的item（单行item）
            if (dateMoneyList) {
              for (let j = 0; j < dateMoneyList.length; j++) {
                let dateMoneyItem = dateMoneyList[j]
                let subItem1 = {
                  esMoney: '',
                  realMoney: '',
                }
                subItem1.esMoney = dateMoneyItem['esPayment'] ? dateMoneyItem['esPayment'] : ''; //预计付款
                subItem1.realMoney = dateMoneyItem['acPayment'] ? dateMoneyItem['acPayment'] : ''   //实际付款
                dateItem.push(subItem1);    //预付款、实际付款

                let subItem2 = {
                  esMoney: '',
                  realMoney: '',
                }
                subItem2.esMoney = dateMoneyItem['esColection'] ? dateMoneyItem['esColection'] : ''; //预计收款
                subItem2.realMoney = dateMoneyItem['acColection'] ? dateMoneyItem['acColection'] : '';  //实际收款
                dateItem.push(subItem2);
              }
            }

            lineItem.date = flowDetailItem['financeDate']    //日期
            lineItem.financeDateStr = flowDetailItem['financeDateStr']
            lineItem.startQuota = flowDetailItem['initAmount']  //当天初始额度
            lineItem.surplusQuota = flowDetailItem['finalAmount'] //当天总剩余额度
            lineItem.totalPayment = flowDetailItem['expectPaySum'] //当天总贷款发放(付款)
            lineItem.totalCollection = flowDetailItem['expectReceiveSum'] //当天总贷款回收（收款）
            lineItem.rows = dateItem   //每一列的数据
            tableList.push(lineItem)
          }
        }

        this.fundStateDetailList = tableList


      },

      parseBackColor(data) {
        var list = []
        let colorList = ['#D0D7EC', '#D0D7EC', '#fff', '#fff']
        let dateList = data['moneyList']
        let dataItem = dateList[0]
        let dataList = dataItem['dateMoneyList']
        if (dataList) {
          for (let i = 0; i < dataList.length * 2; i++) {
            list.push(colorList[i % 4])
          }
        }

        this.dateMoneyBackColorList = list
      },

      //导出
      exportFundStateList() {
        let endTime = this.endTime ? dayjs(this.endTime).format("YYYY-MM-DD") :'';
        let startTime =this.startTime ? dayjs(this.startTime).format("YYYY-MM-DD") :'';
        let language = window.localStorage.getItem("languageCode") || 'zh_cn'
        let token = utils.getStorage("userProfile") ? utils.getStorage("userProfile").token : '';
        // let exportUrl = this.axios.defaults.baseURL + '/api/zmaExcel/exportFlowExcel?time=' + endTime + '&l_c=' + language + '&token=' + token
        let exportUrl = this.axios.defaults.baseURL + '/api/zmaExcel/exportFlowExcel?startTime=' + startTime + '&endTime=' + endTime +'&flowNumber=' + this.searchFlowNumber + '&l_c=' + language + '&token=' + token
        window.open(exportUrl)
      },
      scrollLeft(){
        let _this = this;
        let tbRight = _this.$refs.tbLeft;
        this.topLeft = tbRight.scrollTop;
        // console.log(this.topLeft);
      },
      scrollRight(){
        let _this = this;
        let tbRight = _this.$refs.tbRight;
        this.topRight = tbRight.scrollTop;
        this.topLeft = 0;
        // console.log(this.topRight);
      }
    },
    mounted() {

    },
  }
</script>

<style lang="scss" scoped>
  .fundStatementDetailVO {
    font-size: 14px;
    padding-bottom: 30px;

    .addMailBoxBtn {
      width: 150px;
      height: 38px;
    }

    .detail-tableView {
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.10);
      width: 100%;
      display: flex;
      height: 550px;
      .tb-h{
        position: absolute;
        z-index: 99;
        top: 0;
      }
      .tb-b{
        margin-top: 90px;
      }
      .tb-left {
        width: 720px;
        position: relative;
        overflow: hidden;
        &.scroll{
          overflow-y: scroll;
        }
        .tb-b{
          overflow: hidden;
        }
      }

      .tb-right {
        flex: 1;
        overflow: scroll;
        position: relative;

        .tb-right-b{
          padding-top: 90px;
        }
      }

      .fundStatementDetail-table {
        border: none;
        font-weight: normal;
        color: #606266;
        text-align: left;
        border-collapse: collapse;

        thead {
          height: 90px;
          line-height: 30px;
          color: #A9B0CE;
          background: #f8fafd;
        }

        tr {
          overflow-x: auto;
        }

        th {
          height: 30px;
          line-height: 30px;
          font-weight: normal;
          text-align: left;
          border-left: 1px solid #EFF0F2;
          width: 150px;
          box-sizing: border-box;
          max-width: 150px;
          background-color: #f8fafd;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          padding: 0 0 0 16px;
        }

        td {
          height: 30px;
          line-height: 30px;
          font-weight: normal;
          text-align: left;
          border-left: 1px solid #EFF0F2;
          width:150px;
          box-sizing: border-box;
          padding-left: 16px;
          max-width: 150px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

          border-bottom: 1px solid #EAEAEA;

          .adminSpan {
            margin: 0 !important;
          }
        }
        .pileView {
          display: flow;
        }
      }

      .dateTable {
        position: relative;
        th {
          height: 90px;
        }
      }
      .companyName{
        &:hover{
          cursor: pointer;
        }
      }
    }

  }

</style>
